/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Flag, Header, Popup, Icon, Divider, Message } from 'semantic-ui-react';
import { colors } from 'utils/colors';
import Fade from 'react-reveal/Fade';
import { SearchTicker, Table, Segment, Button, Loading } from 'components';
import { getTickerSearchResult } from 'utils/helpers';
import { ComparePortfolio, Analytics, Storage } from 'actions';
import cn from 'classnames';
import { withRouter } from 'react-router-dom';
import { translation } from '../../../Translation/scorecard';
import {
  translateAssetClass,
  translateTableHeadings,
} from '../../../../utils/helpers';

class Replace extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearchDisabled: false,
    };
  }

  componentWillMount() {
    const { dispatch, analytics, comparePortfolioState } = this.props;
    const { data } = analytics;
    const { initialSnapshot } = comparePortfolioState;
    window.scrollTo(0, 0);

    this.setSearch();

    dispatch(
      ComparePortfolio.convertAnalyticsPortfolioObjectChange(
        data.portfolio,
        data.paramsPassed,
        data.tickersOriginal,
        // if we are clicking the button to replace holdings from the Bar, show excluded holdings too
        false,
        initialSnapshot
      )
    );

    if (initialSnapshot && comparePortfolioState.portfolio.length) {
      dispatch(
        ComparePortfolio.takeInitialPortfolio(comparePortfolioState.portfolio)
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { comparePortfolioState } = this.props;
    const { isSearchDisabled } = this.state;
    if (isSearchDisabled !== prevState.isSearchDisabled) {
      this.render();
    }
    if (
      comparePortfolioState.portfolio !==
      prevProps.comparePortfolioState.portfolio
    ) {
      this.setSearch();
    }
  }

  getExcluded = () => {
    const myObj = Object.values(this.filterOutGICAndDigitalCurrency());
    const excludedFilter = myObj.filter(
      (el) => el.isExcluded === true || el.isReplaceWhatIf === true
    );
    return excludedFilter;
  };

  getPortfoliosAssociatedAccountName = () => {
    const { analytics } = this.props;
    if (analytics.data.paramsPassed.account)
      if (!analytics.data.paramsPassed.account.label)
        return `${analytics.data.paramsPassed.account.user_institution || ''}`;
      else
        return `${
          analytics.data.paramsPassed.account.user_institution || ''
        }: ${analytics.data.paramsPassed.account.label || ''}`;

    return null;
  };

  getSearchParams = () => {
    const { user_region, toggle_region } = this.props;
    const types = [];
    const currency =
      user_region === 'CA' && toggle_region === 'US' ? 'USD' : '';
    const region = currency === 'USD' ? 'US' : user_region;
    return { region, types };
  };

  decideRegion = () => {
    const { toggle_region, user_region } = this.props;
    if (user_region === 'US') {
      return 'US';
    }
    if (toggle_region === 'US') {
      return 'US';
    }
    return 'CA';
  };

  setSearch = () => {
    this.setState({ isSearchDisabled: this.isSearchDisabled() });
  };

  // For now, we do not have the option to undo on this page.
  // handleMainUndo = () => {
  //   const { dispatch, comparePortfolioState } = this.props;
  //   dispatch(ComparePortfolio.undoBarCompare());
  //   dispatch(
  //     Analytics.getSnapshot(comparePortfolioState.initialAnalyticsSnapshot)
  //   );
  // };

  isDisabled = () => {
    const { comparePortfolioState } = this.props;
    const { replacementTickers } = comparePortfolioState;

    return replacementTickers.length === 0;
  };

  isSearchDisabled = () => {
    const { comparePortfolioState } = this.props;

    let hasToggle = false;
    Object.keys(comparePortfolioState.portfolio).forEach((ticker) => {
      if (!hasToggle && comparePortfolioState.portfolio[ticker].isToggled) {
        hasToggle = true;
      }
    });

    return !hasToggle;
  };

  analyzeWhatIf = () => {
    const { history, comparePortfolioState, dispatch, location, analytics } =
      this.props;
    const gicFormat = /^GIC\d*:MKT$/;
    Storage.removeItem('pwpa-has-exclude-holding');
    dispatch(ComparePortfolio.resetCheckWeight());
    dispatch(ComparePortfolio.analyticsInitialSnapshot(false));

    const region = this.decideRegion();

    const params = Object.values(comparePortfolioState.portfolio).reduce(
      (total, item) => {
        if (
          (item.weight && gicFormat.test(item.ticker)) ||
          (item.weight && item.ticker === '~BTCUSDT') ||
          (item.weight && item.ticker === '~ETHUSDT') ||
          (item.weight &&
            item.unadjusted_closing_price &&
            item.unadjusted_closing_price.CAD)
        ) {
          const weight = item.weight / 100;
          total.symbols.push(item.ticker);
          total.weights.push(weight);
        }

        return total;
      },
      { symbols: [], weights: [] }
    );

    const rebalanceInterval = analytics.data.paramsPassed.rebalance_interval;
    const thePortfolio = {
      portfolio_type: 'custom',
      region,
      symbols: params.symbols.join(','),
      weights: params.weights.join(','),
      ...(comparePortfolioState.gic_info &&
        Object.keys(comparePortfolioState.gic_info).length && {
          gic_info: comparePortfolioState.gic_info,
        }),
      is_linked: analytics.data.paramsPassed.is_linked,
      account: analytics.data.paramsPassed.account,
      replacements: comparePortfolioState.replacementTickers,
    };

    dispatch(Storage.setItem('pwpa-portfolio', thePortfolio));
    dispatch(
      Analytics.fetchParams(
        thePortfolio,
        location.state,
        false,
        region,
        rebalanceInterval
      )
    );
    return history.push('/portfolio/unsaved/overview');
  };

  round = (num) => Math.round(num * 100) / 100;

  filterOutGICAndDigitalCurrency = () => {
    const { comparePortfolioState } = this.props;
    // eslint-disable-next-line no-useless-escape
    const gicFormat = /^GIC\d*\:MKT$/;

    return Object.keys(comparePortfolioState.portfolio)
      .filter((key) => !gicFormat.test(key))
      .filter((key) => key !== '~BTCUSDT' && key !== '~ETHUSDT')
      .reduce((obj, key) => {
        obj[key] = comparePortfolioState.portfolio[key];
        return obj;
      }, {});
  };

  showSecurityProxyName = (security) => {
    const { analytics } = this.props;
    const { data } = analytics;
    if (!security) return null;
    return (
      data.portfolio.portfolio_type !== 'custom' &&
      data.tickersValid[security.ticker] &&
      data.tickersValid[security.ticker].wsName
    );
  };

  renderHoldingsTable = () => {
    const { comparePortfolioState, dispatch, analytics, language } = this.props;
    const numHoldings = Object.keys(
      this.filterOutGICAndDigitalCurrency()
    ).length;

    const french = language === 'fr';

    const excluded = this.getExcluded();

    return (
      <Segment
        className="basic compact"
        style={{
          marginTop: '0.5rem',
          padding: '0rem',
          marginBottom: '0rem',
          opacity: comparePortfolioState.isFetching ? 0.5 : 1,
          paddingBottom: '0',
          width: '800px',
        }}
      >
        {excluded.length > 0 ? (
          <div>
            <Header style={{ marginTop: '2rem' }}>
              {translation[language].REPLACE_SUB2}
              <Header.Subheader>
                {translation[language].REPLACE_SUB2_DESC}
              </Header.Subheader>
            </Header>
            <Table
              textAlign="center"
              style={{
                marginBottom: '0rem',
                marginTop: !numHoldings && '0.7rem',
              }}
              singleLine
            >
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell
                    colSpan="2"
                    style={{ background: 'rgba(203,232,238,0.3)' }}
                  >
                    {translateTableHeadings('Asset', french)}
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{ background: 'rgba(203,232,238,0.3)' }}
                  >
                    {translateTableHeadings('Exchange', french)}
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{ background: 'rgba(203,232,238,0.3)' }}
                  >
                    {translateTableHeadings('Class', french)}
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    width={3}
                    style={{ background: 'rgba(203,232,238,0.3)' }}
                  >
                    {translateTableHeadings('Price', french)}
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    colSpan={3}
                    width={3}
                    style={{ background: 'rgba(203,232,238,0.3)' }}
                  >
                    {translateTableHeadings('Start Date', french)}{' '}
                    <Popup
                      trigger={
                        <Icon
                          name="question circle outline"
                          style={{ fontSize: '1rem', verticalAlign: 'top' }}
                        />
                      }
                      position="right center"
                      content={translation[language].START_DATE_TOOLTIP}
                    />
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      background: 'rgba(203,232,238,0.3)',
                      position: 'relative',
                    }}
                  >
                    {translateTableHeadings('Weight', french)}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {excluded.map((security) => (
                  <StyledRow
                    negative={!security.unadjusted_closing_price.CAD}
                    key={security.ticker}
                    style={{
                      height: '70px',
                      position: 'relative',
                    }}
                  >
                    <Table.Cell collapsing>
                      <i
                        className={
                          comparePortfolioState.portfolio[security.ticker]
                            .isToggled
                            ? 'replaceCheckbox'
                            : 'emptyCheckbox'
                        }
                        onClick={() => {
                          dispatch(
                            ComparePortfolio.updateToggleCheck(
                              security.ticker,
                              security.weight,
                              analytics
                            )
                          );
                        }}
                        style={{
                          position: 'absolute',
                          left: '-1px',
                          zIndex: 10,
                          cursor: 'pointer',
                        }}
                      >
                        {security.isToggled || security.isToggled === null ? (
                          <Icon
                            name="checkmark"
                            style={{ transform: 'translate(-2px, -2px)' }}
                            size="small"
                          />
                        ) : (
                          ' '
                        )}
                      </i>
                    </Table.Cell>
                    <Table.Cell
                      width={5}
                      style={{
                        position: 'relative',
                        zIndex: '0',
                        paddingLeft: '1.2rem',
                      }}
                    >
                      {security.ticker || 'N/A'}{' '}
                      {security.isExcluded && (
                        <Popup
                          trigger={
                            <Icon
                              name="exchange"
                              style={{ color: `${colors.red}` }}
                            />
                          }
                          position="right center"
                          content={translation[language].REPLACE_TABLE_TOOLTIP}
                        />
                      )}
                      {this.showSecurityProxyName(security) &&
                        !analytics.data.paramsPassed.is_linked && (
                          <Popup
                            style={{ marginTop: '20px' }}
                            trigger={
                              <Icon
                                name="question circle outline"
                                style={{
                                  fontSize: '15px',
                                  verticalAlign: 'initial',
                                  color: 'dimgrey',
                                  margin: '0',
                                }}
                              />
                            }
                            position="bottom center"
                            wide
                            content={`This is the proxy ETF for ${this.showSecurityProxyName(
                              security
                            )}`}
                          />
                        )}
                      <SecurityName>{security.long_name || 'N/A'}</SecurityName>
                      {!security.unadjusted_closing_price.CAD && (
                        <Error>
                          <Popup
                            trigger={
                              <Icon
                                style={{
                                  transform: 'translate(-20px, -4px)',
                                  position: 'absolute',
                                  display: 'block',
                                  marginTop: '0',
                                }}
                                name="exclamation circle"
                              />
                            }
                            position="left center"
                            content={translation[language].ZERO_PRICE}
                          />
                        </Error>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {!security.exchange_symbol ||
                      security.exchange_symbol === 'NULL'
                        ? 'N/A'
                        : security.exchange_symbol}
                    </Table.Cell>
                    <Table.Cell>
                      {security.global_asset_class
                        ? translateAssetClass(
                            french,
                            security.global_asset_class
                          )
                        : 'N/A'}
                    </Table.Cell>
                    <Table.Cell>
                      $
                      {this.round(
                        security.unadjusted_closing_price[
                          security.default_currency
                        ] || 0
                      )}
                      <Flag
                        name={security.default_currency === 'CAD' ? 'ca' : 'us'}
                        style={{ marginLeft: '0.3rem' }}
                      />
                    </Table.Cell>
                    <Table.Cell colSpan={3}>
                      {security.start_date || 'N/A'}
                    </Table.Cell>
                    <Table.Cell width={3}>
                      {!!security.unadjusted_closing_price.CAD
                        ? security.replacedWeight
                          ? `${this.round(security.replacedWeight)}%`
                          : `${this.round(security.weight)}%`
                        : 'N/A'}
                    </Table.Cell>
                  </StyledRow>
                ))}
              </Table.Body>
            </Table>
          </div>
        ) : (
          <div className="message-wrap">
            <Message>{translation[language].REPLACE_EMPTY_MESSAGE}</Message>
          </div>
        )}
      </Segment>
    );
  };

  render() {
    const { comparePortfolioState, analytics, language } = this.props;
    let { name } = comparePortfolioState.original;
    const { data } = analytics;
    const { search, isFetching } = comparePortfolioState;
    const { isSearchDisabled } = this.state;

    // if name is null, check to see if this portfolio is an account that was analyzed
    // if it is, set the name to '<account.user_institution>: <account.label>'
    name = name || this.getPortfoliosAssociatedAccountName();
    const params = this.getSearchParams();
    const french = language === 'fr';

    return (
      <div>
        {isFetching ? <Loading active /> : null}
        <StyledDiv>
          <Fade duration={1500}>
            <div>
              <Header style={{ textAlign: 'center', width: '100%' }}>
                <span style={{ marginBottom: '1rem' }}>
                  {translation[language].REPLACE_TITLE}
                </span>
                <Header.Subheader
                  style={{
                    textAlign: 'justify',
                    maxWidth: '48rem',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  {translation[language].REPLACE_DESCRIPTION.P1}{' '}
                  {name && (
                    <span>
                      <span>{` ('`}</span>
                      <span style={{ color: colors.red }}>
                        {name === 'Overview; All Accounts' && french
                          ? 'Vue d’ensemble; Tous les Comptes'
                          : name}
                      </span>
                      <span>{`')`}</span>
                    </span>
                  )}{' '}
                  {translation[language].REPLACE_DESCRIPTION.P2}
                  {!data.paramsPassed.is_linked &&
                    'Note that proxy ETFs are being used below.'}
                </Header.Subheader>

                <Header.Subheader
                  style={{
                    marginTop: '1rem',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    textAlign: 'justify',
                    maxWidth: '48rem',
                  }}
                >
                  {translation[language].REPLACE_DESCRIPTION.P3}
                </Header.Subheader>
              </Header>
              <Divider style={{ width: '90%' }} />
              <TableContainer>
                <Header style={{ marginTop: '0' }}>
                  {translation[language].REPLACE_SUB1}
                </Header>

                {isSearchDisabled ? (
                  <Popup
                    trigger={
                      <div>
                        <SearchTicker
                          loading={
                            comparePortfolioState.isFetchingSearchResults
                          }
                          results={getTickerSearchResult(search)}
                          featureAction={ComparePortfolio}
                          types={params.types}
                          disabled={isSearchDisabled}
                          french={french}
                        />
                      </div>
                    }
                    content={translation[language].REPLACE_SEARCH_TOOLTIP}
                    position="right center"
                  />
                ) : (
                  <SearchTicker
                    loading={comparePortfolioState.isFetchingSearchResults}
                    results={getTickerSearchResult(search)}
                    featureAction={ComparePortfolio}
                    types={params.types}
                    disabled={isSearchDisabled}
                    french={french}
                  />
                )}

                {!isFetching && this.renderHoldingsTable()}
              </TableContainer>
              <div>
                <Button
                  className={cn('left centered', {
                    disabled: this.isDisabled(),
                  })}
                  style={{
                    margin: '3rem 0 0 1rem',
                    position: 'relative',
                    display: 'inline-block',
                  }}
                  color={colors.darkBlue}
                  icon="line chart"
                  onClick={this.analyzeWhatIf}
                >
                  {translation[language].ANALYZE}
                </Button>
              </div>
            </div>
          </Fade>
        </StyledDiv>
      </div>
    );
  }
}

Replace.propTypes = {
  analytics: PropTypes.object,
  location: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  comparePortfolioState: PropTypes.object,
  history: PropTypes.object.isRequired,
  user_region: PropTypes.string,
  toggle_region: PropTypes.string,
  language: PropTypes.string,
};

Replace.defaultProps = {
  dispatch: () => null,
  comparePortfolioState: {},
  analytics: {},
  user_region: 'CA',
  toggle_region: 'CA',
  language: 'en',
};

export default withRouter(
  connect((state) => ({
    comparePortfolioState: state.ComparePortfolio,
    analytics: state.Analytics,
    user_region: state.Storage.user_region,
    toggle_region: state.Storage.toggle_region || 'CA',
    language: state.Storage.language,
  }))(Replace)
);

const TableContainer = styled(({ className, children, ...rest }) => (
  <div className={className} {...rest}>
    {children}
  </div>
))`
  & {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 1rem;
    padding-top: 1rem;
    border-radius: 8px;
    position: relative;
  }

  .warning {
    height: 15px;
    font-size: 13px;
    font-style: italic;
    margin-top: 7px;
    color: ${colors.grey};
  }

  .message-wrap {
    margin: auto;
    width: fit-content;
    padding-top: 2rem;
    max-width: 48rem;
  }
`;

const StyledDiv = styled.div`
  & {
    // border: 2px solid ${colors.blue};
    // border-radius: 4px;
    width: 100%;
    height: 100%;
    display: flex;
    padding: 3rem 0;
    flex-direction: column;
    justify-content: flex-start;
    & > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      div.search {
        .results {
          .category {
            align-items: flex-start;
          }
        }
      }
    }
  }
  #table-container {
    text-align: center;
  }
`;

const SecurityName = styled.div`
  font-size: 0.9rem;
  line-height: 1rem;
  color: ${(props) =>
    props.negative ? 'rgba(159,58,56, 0.6)' : 'rgba(0,0,0,0.5)'};
`;

const StyledRow = styled(({ className, children, ...rest }) => (
  <Table.Row className={className} {...rest}>
    {children}
  </Table.Row>
))`
  position: relative;
  .close {
    position: absolute;
    top: 10%;
    display: block;
    margin: -10px;
    margin-top: 20px;
    z-index: 100;
    transform: rotate(45deg);
    text-align: center;
    font-size: 1.7rem;
    font-style: normal;
    border-radius: 18px;
    height: 20px;
    width: 20px;
    line-height: 17px;
    padding: 0 1px;
    background: white;
    border: 1px solid #e4e5e5;
    color: black;
    cursor: pointer;
    transition: background 0.1s ease, border 0.1s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &:hover {
      background: #fff6f6;
      border: 1px solid #db2828;
    }
  }
	  .emptyCheckbox {
    position: absolute;
    top: 10%;
    display: block;
    margin: -10px;
    margin-top: 20px;
    text-align: center;
    font-size: 1.7rem;
    font-style: normal;
    border-radius: 3px;
    height: 20px;
    width: 20px;
    line-height: 17px;
    background: white;
    border: 1px solid #2185d0;
    color: rgb(28, 42, 114);
    cursor: pointer;
    transition: background 0.1s ease, border 0.1s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &:hover {
      background: #f1f2f7;
      border: 1px solid rgb(28, 42, 114);
    }
  }
  .replaceCheckbox {
    position: absolute;
    top: 10%;
    display: block;
    margin: -10px;
    margin-top: 20px;
    text-align: center;
    font-size: 1.7rem;
    font-style: normal;
    border-radius: 3px;
    height: 20px;
    width: 20px;
    line-height: 17px;
    background: white;
    border: 1px solid #2185d0;
    color: black;
    cursor: pointer;
    transition: background 0.1s ease, border 0.1s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &:hover {
      background: #f1f2f7;
      border: 1px solid rgb(28, 42, 114);
    }
`;

const Error = styled.div`
  font-size: 1.7rem;
  position: absolute;
  top: 50%;
  left: -2.3rem;
  margin: -0.8rem auto;
  color: ${colors.red};
`;
